import React, { useState, useEffect } from "react";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import JobListingCommunityAccordion from "../components/joblisting/JobListingCommunityAccordion";
import { getJobListing } from "../core/job_listing";
import { getJobsBudgesLastTime } from "../core/communities";
import { JOB_VIEWED_CHANGED, removeJobFromUnseenSet } from "../utils/jobsViewed";
import JobsSkeleton from "../components/skeletons/JobsSkeleton";
import { getSessionData } from "../utils/auth";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';

const Jobs = () => {

    usePageTitle('Jobs - Wefayo');

    const [unseenJobIds, setUnseenJobIds] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    let loggedInUser = getSessionData();

    useEffect(() => {
        const isMountedRef = { current: true };
        const initJobBadges = async () => {
            if (loggedInUser === null) {
                if (isMountedRef.current) {
                    setUnseenJobIds(null);
                }
                return;
            }
            try {
                const data = await getJobsBudgesLastTime();
                if (!isMountedRef.current) return;
                const ids = Array.isArray(data?.unseen_job_ids) ? data.unseen_job_ids : [];
                setUnseenJobIds(new Set(ids.map((id) => String(id))));
            } catch (_err) {
                if (isMountedRef.current) {
                    setUnseenJobIds(new Set());
                }
            }
        };
        initJobBadges();
        return () => { isMountedRef.current = false; };
    }, [loggedInUser?._id]);

    useEffect(() => {
        const handleJobViewed = (event) => {
            const jobId = event?.detail?.jobId;
            if (jobId == null || jobId === '') {
                return;
            }
            setUnseenJobIds((prev) => removeJobFromUnseenSet(prev, jobId));
        };
        window.addEventListener(JOB_VIEWED_CHANGED, handleJobViewed);
        return () => window.removeEventListener(JOB_VIEWED_CHANGED, handleJobViewed);
    }, []);


    return (
        <CommunityLayout currentPage={"jobs"} onCommunitiesLoaded={()=>{}} >
            {/* {isLoading &&
                <div className="w-full">
                    <JobsSkeleton />
                </div>
            } */}
            <div className="flex-grow flex flex-col w-full  ">
                <JobListingCommunityAccordion
                    isOpenInitially={true}
                    key={'jobslisting-community'}
                    unseenJobIds={unseenJobIds}
                />
            </div>
        </CommunityLayout>
    );
};

export default Jobs;